<div class="table-responsive animated fadeIn slow">
    <h2 class="text-center titulo">LISTADO DE PÓLIZAS</h2>

    <button type="button" class="btn-agregar" data-bs-toggle="modal" data-bs-target="#polizaModal">  <i class="fas fa-file-invoice-dollar"></i>
    AGREGAR PÓLIZA
  </button>
</div>

<div class="table-wrapper">
    <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="tabla-asignaturas">

        <thead>
            <tr>
                <th style="text-align:center;">Mes</th>
                <th style="text-align:center;">Tipo</th>
                <th style="text-align:center;">Número</th>
                <th style="text-align:center;">Tipo de operación</th>
                <th style="text-align:center;">Descripción</th>
                <th style="text-align:center;">Fecha de registro</th>
                <th style="text-align:center;">Departamento</th>
                <th style="text-align:center;">Ver</th>
                <th style="text-align:center;">Editar</th>
                <th style="text-align:center;">Eliminar</th>

            </tr>
        </thead>

        <tbody>
            <tr *ngFor="let poliza of polizas">
                <td>{{ poliza.mes }}</td>
                <td>{{ poliza.tipo }}</td>
                <td>{{ poliza.numero }}</td>
                <td>{{ poliza.tipo_operacion }}</td>
                <td>{{ poliza.descripcion }}</td>
                <td>{{ poliza.fecha_creacion | date:'dd/MM/yyyy'}}</td>
                <td>{{ poliza.departamento }}</td>
                <td style="text-align:center;">
                    <button class="btn-icon ver" data-bs-toggle="modal" data-bs-target="#VerPoliza" (click)="verpoliza(poliza.id)">
            <i class="fas fa-eye"></i>
          </button>
                </td>
                <td>
                    <button class="btn-icon editar" data-bs-toggle="modal" data-bs-target="#EditarPoliza" (click)="abrirEditarPoliza(poliza)">
  <i class="fas fa-edit"></i>
</button>

                </td>
                <td>
                    <button class="btn-icon eliminar" (click)="eliminarPoliza(poliza.id)">
    <i class="fas fa-trash"></i>
  </button>
                </td>

            </tr>
        </tbody>
    </table>
</div>


<div class="modal fade" id="polizaModal" tabindex="-1">
    <div class="modal-dialog modal-editado">
        <div class="modal-content modal-asig">

            <div class="modal-header-asig">
                <h2 class="modal-title-asig">NUEVA PÓLIZA</h2>
            </div>

            <div class="modal-body-asig">

                <!-- FORMULARIO PÓLIZA -->
                <div class="row g-2">
                    <div class="col-md-3">
                        <select class="form-control" [(ngModel)]="poliza.mes">
              <option value="" disabled selected>Mes</option>
              <option *ngFor="let m of [1,2,3,4,5,6,7,8,9,10,11,12]" [value]="m">
                {{ m }}
              </option>
            </select>
                    </div>

                    <div class="col-md-3">
                        <select class="form-control" [(ngModel)]="poliza.tipo">
              <option value="" disabled selected>Tipo</option>
              <option value="D">Diario</option>
              <option value="C">Cheque</option>
              <option value="I">Ingreso</option>
            </select>
                    </div>

                    <div class="col-md-3">
                        <input type="number" class="form-control" placeholder="Número" [(ngModel)]="poliza.numero">
                    </div>

                    <div class="col-md-3">
                        <select class="form-control" [(ngModel)]="poliza.tipo_operacion">
              <option value="" disabled selected>Operación</option>
              <option value="I">Ingreso</option>
              <option value="E">Egreso</option>
            </select>
                    </div>

                    <div class="col-md-3">
                        <input type="date" class="form-control" [(ngModel)]="poliza.fecha_creacion">
                    </div>
                </div>

                <textarea class="form-control mt-3" placeholder="Descripción" [(ngModel)]="poliza.descripcion"></textarea>

                <hr>

                <!-- BUSCADOR -->
                <div class="row mb-3">
                    <div class="col-md-4">
                        <input type="text" class="form-control" placeholder="Buscar factura" [(ngModel)]="textoBusqueda" (input)="filtrarFacturas()">
                    </div>
                </div>

                <!-- TABLA -->
                <div class="table-wrapper">
                    <table class="tabla-asignaturas">
                        <thead>
                            <tr>
                                <th style="text-align:center;">Acción</th>
                                <th style="text-align:center;">Tipo tercero</th>
                                <th style="text-align:center;">Tipo operación</th>
                                <th style="text-align:center;">Efectos fiscales</th>
                                <th>Folio</th>
                                <th>UUID</th>
                                <th>Emisor</th>
                                <th style="text-align:right;">Exento</th>
                                <th style="text-align:right;">Tasa 0%</th>
                                <th style="text-align:right;">Tasa 16%</th>
                                <th style="text-align:right;">Subtotal</th>
                                <th style="text-align:right;">IVA</th>
                                <th style="text-align:right;">ISR</th>
                                <th style="text-align:right;">Ajuste</th>
                                <th style="text-align:right;">Total</th>
                                <th>Departamento</th>
                            </tr>
                        </thead>

                        <tbody>

                            <tr *ngFor="let f of facturasPaginadas; trackBy: trackById">

                                <td style="text-align:center;">
                                    <button type="button" [ngClass]="facturasSeleccionadasMap[f.id] ? 'btn-cancelar' : 'btn-guardar'" (click)="seleccionarFactura(f.id)">
                    {{ facturasSeleccionadasMap[f.id] ? 'Quitar' : 'Seleccionar' }}
                  </button>
                                </td>
                                <td> <select class="form-control" [(ngModel)]="f.tipo_tercero" required>
                        <option value="04"> PROVEEDOR NACIONAL</option>
                        <option value="05"> PROVEEDOR EXTRANJERO</option>
                        <option value="15"> PROVEEDOR GLOBAL</option>
                        </select></td>
                                <td><select class="form-control" [(ngModel)]="f.tipo_operacion" required>
                        <option value="02"> ENAJENACION DE BIENES</option>
                        <option value="03"> PRESTACION DE SERV PROF</option>
                        <option value="06"> USO O GOCE TEMPORAL DE BIENES</option>
                        <option value="08"> IMPORTACION POR TRANSF VIRTUAL</option>
                        <option value="85"> OTROS</option>
                        <option value="07"> IMPORTACION DE BIENES O SERV</option>
                        <option value="87"> OPERACIONES GLOBALES</option>
                        </select></td>
                                <td><select class="form-control" [(ngModel)]="f.efectos_fiscal" required>
                        <option value="01"> Si</option>
                        <option value="02"> No</option>
                        </select></td>
                                <td>{{ f.folio }}</td>
                                <td>{{ f.uuid }}</td>
                                <td>{{ f.nombre_emisor }}</td>
                                <td style="text-align:right;">
                                    <input type="number" class="form-control" [(ngModel)]="f.exento" [disabled]="!facturasSeleccionadasMap[f.id]">
                                </td>
                                <td style="text-align:right;">
                                    <input type="number" class="form-control" [(ngModel)]="f.tasa0" [disabled]="!facturasSeleccionadasMap[f.id]">
                                </td>

                                <td style="text-align:right;">
                                    <input type="number" class="form-control" [(ngModel)]="f.tasa16" [disabled]="!facturasSeleccionadasMap[f.id]">
                                </td>
                                <td style="text-align:right;">
                                    <input type="number" class="form-control" [(ngModel)]="f.subtotal" [disabled]="!facturasSeleccionadasMap[f.id]">
                                </td>

                                <td style="text-align:right;">
                                    <input type="number" class="form-control" [(ngModel)]="f.iva" [disabled]="!facturasSeleccionadasMap[f.id]">
                                </td>

                                <td style="text-align:right;">
                                    <input type="number" class="form-control" [(ngModel)]="f.isr" [disabled]="!facturasSeleccionadasMap[f.id]">
                                </td>
                                <td style="text-align:right;">
                                    <input type="number" class="form-control" [(ngModel)]="f.ajuste" [disabled]="!facturasSeleccionadasMap[f.id]">
                                </td>
                                <td style="text-align:right;">
                                    {{ calcularTotal(f) | number:'1.2-2' }}
                                </td>
                                <td>{{ f.tipoprestacion }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <!-- SIN RESULTADOS -->
                <div *ngIf="facturasFiltradas.length === 0" class="text-center text-muted mt-3">
                    No hay facturas que coincidan
                </div>

                <!-- PAGINACIÓN -->
                <div class="d-flex justify-content-center mt-3" *ngIf="totalPaginas > 1">
                    <button class="btn-cancelar mx-1" (click)="cambiarPagina(paginaActual - 1)" [disabled]="paginaActual === 1">
            «
          </button>

                    <button class="btn-guardar mx-1" *ngFor="let p of [].constructor(totalPaginas); let i = index" [ngClass]="paginaActual === i + 1 ? 'btn-cancelar' : 'btn-guardar'" (click)="cambiarPagina(i + 1)">
            {{ i + 1 }}
          </button>

                    <button class="btn-cancelar mx-1" (click)="cambiarPagina(paginaActual + 1)" [disabled]="paginaActual === totalPaginas">
            »
          </button>
                </div>

            </div>

            <div class="modal-footer-asig">
                <button class="btn-cancelar" data-bs-dismiss="modal">
          Cancelar
        </button>
                <button class="btn-guardar" (click)="guardarPoliza()">
          Guardar Póliza
        </button>
            </div>

        </div>
    </div>
</div>

<div class="modal fade" id="VerPoliza" tabindex="-1">
    <div class="modal-dialog modal-editado">
        <div class="modal-content modal-asig">

            <div class="modal-header-asig d-flex justify-content-between align-items-center">
                <h2 class="modal-title-asig">
                    LISTADO DE FACTURAS EN POLIZA
                </h2>

            </div>

            <div class="modal-body-asig">
                <BR>
                <div class="table-wrapper">
                    <table class="tabla-asignaturas">
                        <thead>
                            <tr>
                                <th style="text-align:center;">Tipo tercero</th>
                                <th style="text-align:center;">Tipo operación</th>
                                <th style="text-align:center;">Efectos fiscales</th>

                                <th>RFC</th>
                                <th>UUID</th>

                                <th style="text-align:right;">Exento</th>
                                <th style="text-align:right;">Tasa 0</th>
                                <th style="text-align:right;">Tasa 16</th>
                                <th style="text-align:right;">IVA</th>
                                <th style="text-align:right;">ISR</th>
                                <th style="text-align:right;">Ajuste</th>

                                <th style="text-align:right;">Subtotal</th>
                                <th style="text-align:right;">Total</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let f of facturasPoliza">

                                <td>{{ (f.tipo_tercero || '').toString().padStart(2, '0') }}</td>

                                <td>
                                    {{ (f.tipo_operacion_factura || '').toString().padStart(2, '0') }}
                                </td>

                                <td>
                                    {{ (f.efectos_fiscal || '').toString().padStart(2, '0') }}
                                </td>


                                <td>{{ f.rfc_emisor }}</td>

                                <td>{{ f.uuid }}</td>



                                <td style="text-align:right;">
                                    {{ (f.exento || 0) | number:'1.2-2' }}
                                </td>

                                <td style="text-align:right;">
                                    {{ (f.tasa0 || 0) | number:'1.2-2' }}
                                </td>

                                <td style="text-align:right;">
                                    {{ (f.tasa16 || 0) | number:'1.2-2' }}
                                </td>

                                <td style="text-align:right;">
                                    {{ (f.iva || 0) | number:'1.2-2' }}
                                </td>

                                <td style="text-align:right;">
                                    {{ (f.isr || 0) | number:'1.2-2' }}
                                </td>
                                <td style="text-align:right;">
                                    {{ (f.ajuste || 0) | number:'1.2-2' }}
                                </td>
                                <td style="text-align:right;">
                                    {{ (f.subtotal || 0) | number:'1.2-2' }}
                                </td>

                                <td style="text-align:right;">
                                    {{ (f.total || 0) | number:'1.2-2' }}
                                </td>

                            </tr>

                            <tr class="fila-total">
                                <td colspan="11" style="text-align:right; font-weight:bold;">
                                    TOTAL
                                </td>

                                <td style="text-align:right; font-weight:bold;">
                                    {{ totalFacturasPoliza | number:'1.2-2' }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <div class="modal-footer-asig">
                <button class="btn-cancelar" data-bs-dismiss="modal">
          Cerrar
        </button>
            </div>

        </div>
    </div>
</div>

<div class="modal fade" id="EditarPoliza" tabindex="-1">
    <div class="modal-dialog modal-editado">
        <div class="modal-content modal-asig">

            <div class="modal-header-asig">
                <h2 class="modal-title-asig">EDITAR PÓLIZA</h2>
            </div>

            <div class="modal-body-asig">

                <!-- DATOS PÓLIZA -->
                <div class="row g-2">
                    <div class="col-md-3">
                        <select class="form-control" [(ngModel)]="polizaEdit.mes">
                            <option value="" disabled selected>Mes</option>
                            <option *ngFor="let m of [1,2,3,4,5,6,7,8,9,10,11,12]" [value]="m">
                                {{ m }}
                            </option>
                        </select>
                    </div>

                    <div class="col-md-3">
                        <select class="form-control" [(ngModel)]="polizaEdit.tipo">
                            <option value="" disabled selected>Tipo</option>
                            <option value="D">Diario</option>
                            <option value="C">Cheque</option>
                            <option value="I">Ingreso</option>
                        </select>
                    </div>

                    <div class="col-md-3">
                        <input class="form-control" [(ngModel)]="polizaEdit.numero" placeholder="Número">
                    </div>

                    <div class="col-md-3">
                        <select class="form-control" [(ngModel)]="polizaEdit.tipo_operacion">
                            <option value="" disabled selected>Operación</option>
                            <option value="I">Ingreso</option>
                            <option value="E">Egreso</option>
                        </select>
                    </div>
                    <div class="col-md-3">
                        <input type="date" class="form-control" [(ngModel)]="polizaEdit.fecha_creacion">
                    </div>
                </div>

                <textarea class="form-control mt-3" [(ngModel)]="polizaEdit.descripcion" placeholder="Descripción"></textarea>

                <hr>

                <h5>Facturas en la póliza</h5>

                <table class="tabla-asignaturas">

                    <thead>
                        <tr>
                            <th>Folio</th>
                            <th>UUID</th>
                            <th>Emisor</th>
                            <th>Exento</th>
                            <th>Tasa 0%</th>
                            <th>Tasa 16%</th>
                            <th>Subtotal</th>
                            <th>IVA</th>
                            <th>ISR</th>
                            <th>Ajuste</th>
                            <th>Total</th>
                            <th>Prestación</th>
                            <th>Acción</th>
                        </tr>
                    </thead>

                    <tr *ngFor="let f of facturasPolizaEditPaginadas">
                        <td>{{ f.folio }}</td>
                        <td>{{ f.uuid }}</td>
                        <td>{{ f.nombre_emisor }}</td>

                        <td>
                            <input type="number" class="form-control" [(ngModel)]="f.exento">
                        </td>

                        <td>
                            <input type="number" class="form-control" [(ngModel)]="f.tasa0">
                        </td>

                        <td>
                            <input type="number" class="form-control" [(ngModel)]="f.tasa16">
                        </td>

                        <td>
                            <input type="number" class="form-control" [(ngModel)]="f.subtotal">
                        </td>

                        <td>
                            <input type="number" class="form-control" [(ngModel)]="f.iva">
                        </td>

                        <td>
                            <input type="number" class="form-control" [(ngModel)]="f.isr">
                        </td>

                        <td>
                            <input type="number" class="form-control" [(ngModel)]="f.ajuste">
                        </td>

                        <td>
                            {{ calcularTotal(f) | number:'1.2-2' }}
                        </td>

                        <td>{{ f.tipoprestacion }}</td>

                        <td>
                            <button class="btn-cancelar" (click)="quitarFacturaEdit(f.id_factura)">
                                Quitar
                            </button>
                        </td>
                    </tr>
                </table>

                <div class="d-flex justify-content-center mt-3" *ngIf="totalPaginasPolizaEdit > 1">

                    <button class="btn-cancelar mx-1" (click)="cambiarPaginaPolizaEdit(paginaActualPolizaEdit - 1)" [disabled]="paginaActualPolizaEdit === 1">
                        «
                    </button>

                    <button class="btn-guardar mx-1" *ngFor="let p of [].constructor(totalPaginasPolizaEdit); let i = index" [ngClass]="paginaActualPolizaEdit === i + 1 ? 'btn-cancelar' : 'btn-guardar'" (click)="cambiarPaginaPolizaEdit(i + 1)">
                        {{ i + 1 }}
                    </button>

                    <button class="btn-cancelar mx-1" (click)="cambiarPaginaPolizaEdit(paginaActualPolizaEdit + 1)" [disabled]="paginaActualPolizaEdit === totalPaginasPolizaEdit">
                        »
                    </button>

                </div>

                <hr>

                <h5>Agregar facturas</h5>

                <table class="tabla-asignaturas">
                    <thead>
                        <tr>
                            <th>Tercero</th>
                            <th>Operación</th>
                            <th>Efecto Fiscal</th>
                            <th>Folio</th>
                            <th>UUID</th>
                            <th>Emisor</th>
                            <th>Exento</th>
                            <th>Tasa 0%</th>
                            <th>Tasa 16%</th>
                            <th>Subtotal</th>
                            <th>IVA</th>
                            <th>ISR</th>
                            <th>Ajuste</th>
                            <th>Total</th>
                            <th>Prestación</th>
                            <th>Acción</th>
                        </tr>
                    </thead>


                    <tr *ngFor="let f of facturasDisponiblesEditPaginadas">
                        <td>
                            <select class="form-control" [(ngModel)]="f.tipo_tercero">
            <option value="04">PROVEEDOR NACIONAL</option>
            <option value="05">PROVEEDOR EXTRANJERO</option>
            <option value="15">PROVEEDOR GLOBAL</option>
        </select>
                        </td>

                        <td>
                            <select class="form-control" [(ngModel)]="f.tipo_operacion">
            <option value="02">ENAJENACION DE BIENES</option>
            <option value="03">PRESTACION DE SERV PROF</option>
            <option value="06">USO O GOCE TEMPORAL</option>
            <option value="08">IMPORTACION VIRTUAL</option>
            <option value="85">OTROS</option>
            <option value="07">IMPORTACION</option>
            <option value="87">OPERACIONES GLOBALES</option>
        </select>
                        </td>

                        <td>
                            <select class="form-control" [(ngModel)]="f.efectos_fiscal">
            <option value="01">Sí</option>
            <option value="02">No</option>
        </select>
                        </td>

                        <td>{{ f.folio }}</td>
                        <td>{{ f.uuid }}</td>
                        <td>{{ f.nombre_emisor }}</td>

                        <td>
                            <input type="number" class="form-control" [(ngModel)]="f.exento" [disabled]="!facturasEditIds.includes(f.id)">
                        </td>

                        <td>
                            <input type="number" class="form-control" [(ngModel)]="f.tasa0" [disabled]="!facturasEditIds.includes(f.id)">
                        </td>

                        <td>
                            <input type="number" class="form-control" [(ngModel)]="f.tasa16" [disabled]="!facturasEditIds.includes(f.id)">
                        </td>

                        <td>
                            <input type="number" class="form-control" [(ngModel)]="f.subtotal" [disabled]="!facturasEditIds.includes(f.id)">
                        </td>

                        <td>
                            <input type="number" class="form-control" [(ngModel)]="f.iva" [disabled]="!facturasEditIds.includes(f.id)">
                        </td>

                        <td>
                            <input type="number" class="form-control" [(ngModel)]="f.isr" [disabled]="!facturasEditIds.includes(f.id)">
                        </td>

                        <td>
                            <input type="number" class="form-control" [(ngModel)]="f.ajuste" [disabled]="!facturasEditIds.includes(f.id)">
                        </td>

                        <td>
                            {{ calcularTotal(f) | number:'1.2-2' }}
                        </td>

                        <td>{{ f.tipoprestacion }}</td>
                        <td>
                            <button class="btn-guardar" (click)="agregarFacturaEdit(f.id)">
                                Agregar
                            </button>
                        </td>
                    </tr>
                </table>

                <!-- PAGINACIÓN AGREGAR -->
                <div class="d-flex justify-content-center mt-3" *ngIf="totalPaginasEdit > 1">

                    <button class="btn-cancelar mx-1" (click)="cambiarPaginaEdit(paginaActualEdit - 1)" [disabled]="paginaActualEdit === 1">
                        «
                    </button>

                    <button class="btn-guardar mx-1" *ngFor="let p of [].constructor(totalPaginasEdit); let i = index" [ngClass]="paginaActualEdit === i + 1 ? 'btn-cancelar' : 'btn-guardar'" (click)="cambiarPaginaEdit(i + 1)">
                        {{ i + 1 }}
                    </button>

                    <button class="btn-cancelar mx-1" (click)="cambiarPaginaEdit(paginaActualEdit + 1)" [disabled]="paginaActualEdit === totalPaginasEdit">
                        »
                    </button>

                </div>

            </div>

            <div class="modal-footer-asig">
                <button class="btn-cancelar" data-bs-dismiss="modal">Cancelar</button>
                <button class="btn-guardar" (click)="guardarEdicionPoliza()">Guardar cambios</button>
            </div>

        </div>
    </div>
</div>